<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('project_tag.update_title') }}</span>
            <span v-else>{{ $t('project_tag.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-group :label="$t('project_tag.tag_id')">
          <TagSelect
            :class="{ 'treeselect-error' : fErr('tag_id') }"
            :placeholder="$t('project_tag.placeholders.tag_id')"
            config="async" :delayed="false"
            v-model="entity.tag_id"
            :showAllTags="true"
            />
          <span class="error-text">{{ fErr('tag_id') }}</span>
        </b-form-group>
        <b-form-checkbox v-model="entity.hide">
          {{$dt('project_tag.hide', 'Hide Tag')}}
        </b-form-checkbox>

        <b-form-group :invalid-feedback="fErr('color')">
          <label>{{ $t('project_tag.color') }}</label>
          <!-- <b-form-input type="text" :placeholder="$t('label_set_tag.color_placeholder')"
            :class="{ 'is-invalid' : fErr('color') }"
            v-model="entity.color"/> -->
          <Sketch :value="entity.color" @input="(value)=>{entity.color = value.hex}" />
        </b-form-group>

      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <!-- <router-view :to="{ name: 'LabelSetTags' }"> -->
          <b-button type="reset" variant="info" class="ml-2" @click="$emit('cancel')">
            {{ $t('global.cancel') }}
          </b-button>
        <!-- </router-view> -->
      </div>
    </b-card>
  </div>
</template>

<script>
import { Sketch } from 'vue-color';
import { mapGetters, mapState, mapActions } from 'vuex';
import merge from 'lodash.merge';
import VT from '@/store/types';
import Services from '@/services/index';

// import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import TagSelect from '@/views/Shared/TagSelect';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          color: '#ff00ff',
          hide: false,
        };
      },
    },
    project_id: {
      type: Number,
      required: true
    },
  },
  components: {
    // Treeselect,
    Sketch,
    TagSelect,
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
    ...mapState('Auth', ['activeProjectId']),
    projectId() { return this.project_id || this.activeProjectId; },
  },
  methods: {
    ...mapActions('Project', [VT.PROJECT_LOAD]),
    getForUpdate: Services.projectTags.editData,
    getForCreate: Services.projectTags.createData,
    pushUpdate: Services.projectTags.update,
    pushCreate: Services.projectTags.create,
    load() {
      console.log(this.project_id);
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.projectId, this.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.projectTag : { ...this.entity, ...data.data.projectTag };
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.projectId, { ...this.entity, project_id: this.projectId }).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        // update project info
        this[VT.PROJECT_LOAD](this.activeProjectId);
        if (!this.isUpdateForm) {
          // After successful create
          // if (this.$can('edit', 'label_set_tags')) {
          // this.$router.push({ name: 'LabelSetTagUpdate', params: { id: data.data.id } });
          // } else { // do not redirect if cannot edit
          //   this.entity = this.$options.props.value.default();
          //   this.load();
          // }
        }
        this.$emit('saved');
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
  }
};
</script>

<style scoped>
</style>
